






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TextLabel extends Vue {
  @Prop({ required: false })
  configStyle!: string;
}
